import * as constants from "../../constants";

const initialState = {
  paymentType: constants.PAYMENT_TYPE_CREDIT_CARD,
  donateAmount: null,
  bankTransferATMData: null,
  haveOldDonateInfo: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'GOCHI_KID_DONATE_CONFIRM':
      return {
        ...state,
        ...action.paymentData
      };
    case 'GOCHI_KID_SAVE_DONATE_BANK_TRANSFER_ATM_DATA':
      return {
        ...state,
        bankTransferATMData: action.bankTransferATMData
      }
    case 'GOCHI_KID_DONATE_CLEAR':
      return {
        ...initialState
      };
    case 'GOCHI_KID_CLEAR_DONATE_BANK_TRANSFER_ATM_DATA':
      return {
        ...state,
        bankTransferATMData: null
      }
    case 'GOCHI_KID_CHANGE_FLAG_OLD_DONATE_INFO':
      return {
        ...state,
        haveOldDonateInfo: action.haveOldDonateInfo
      }
    default:
      return state;
  }
};
